module.exports = __webpack_public_path__ + "static/media/grainger-logo.70b5da9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grainger-logo.png
// module id = 60
// module chunks = 0